<template>
  <img
    :src="path"
    :alt="extension"
    :title="extension"
    :class="cn(variants({ size }))"
  />
</template>
<script setup>
import { computed } from "vue";
import { extensions, variants } from "@/SharedComponents/File";
import { cn } from "@/Utils/cn";

const props = defineProps({
  variant: {
    type: String,
    validator: (value) => ["default", "gray", "solid"].includes(value),
    default: "default",
  },
  size: {
    type: String,
    validator: (value) => ["xs", "sm", "md", "lg"].includes(value),
    default: "md",
  },
  /**
   * File extension
   * @type {String}
   * can be any file extension or generic file type i.e. image, video, audio, pdf, text, code, archive
   */
  extension: {
    type: String,
    default: "file",
  },
});

const docType = computed(() => {
  for (const values of Object.values(extensions)) {
    if (values[props.extension]) {
      return values[props.extension];
    }
  }
  // defaults to BLANK
  return extensions.generic.default;
});

const path = computed(() => {
  return `/images/filetypes/${
    props.variant
  }/${docType.value.toUpperCase()}.svg`;
});
</script>
